import { UserDTO } from "../DTO/userDTO";
import { VendorDTO } from "../DTO/vendorDTO";
import { BasicRequest } from "./basicRequest";

export class CreateVendorRequest extends BasicRequest{
   
    public vendor! : VendorDTO;
    public user! : UserDTO;
    
    constructor(){
        super();
    }
}